import React, { useState, useEffect } from "react";

export const svg = `<svg width="16" height="16" viewbox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="m.667 2.167 2.308 2.25L1.558 6l.9.917L7 2.333 6 1.5 4.558 3.05 2.167.667l-1.5 1.5ZM14.358 6l-1.416-1.583 2.391-2.25-1.583-1.5-2.392 2.383L9.833 1.5 9 2.333l4.458 4.584.9-.917ZM3 10.183v1.734l2.667 1-2 2.416h-3V12.25L3 10.183Zm12.333 2.067L13 10.183v1.734l-2.667 1 2 2.416h3V12.25ZM12.25 7.975s-1.867-.15-3.342 1.375c0 0 1.825 1.308 3.342-.492v2.434l-2.708.916v.992h.316C9.517 14.283 8.35 15.25 8 15.25c-.35 0-1.517-.967-1.858-2.042h.316v-.991L3.75 11.3V8.867c1.517 1.8 3.342.491 3.342.491C5.633 7.975 3.75 7.975 3.75 7.975 4.658 5.358 5.933 3.458 8 4.733c2.067-1.266 3.342.634 4.25 3.242Zm-3.583 2.833c0 .359-.417.609-.667.609-.25 0-.667-.25-.667-.609 0-.358.3-.891.667-.891.367 0 .667.533.667.891Zm2.75-2.225c-.4.975-.925 1.067-1.75.767.758-.575 1.033-.767 1.75-.767Zm-6.834 0c.717 0 .992.192 1.75.767-.825.3-1.35.208-1.75-.767Z" fill="#595D66"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
